import { Component, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BreadCrumbService } from '@hub/services/breadCrumbService';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'hub-breadcrumb',
  templateUrl: './bread-crumb.component.html',
  styles: [
    `
    .breadcrumb {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      font-size: 1.5em;
      background-color: white;
      margin-bottom: 0;
    }

    .breadcrumb__item,
    .breadcrumb__link {
      display: inline-flex;
      align-items: center;
    }

    .breadcrumb__item {
      line-height: 1;
    }

    .breadcrumb__icon,
    .breadcrumb__title,
    .breadcrumb__separator {
      display: inline-flex;
      align-items: center;
      line-height: 1;
      vertical-align: middle;
    }

    .breadcrumb__separator {
      padding: 0 .5em;
    }

    `
  ]
})

export class BreadCrumbComponent {
  private readonly subscriptions = new Subscription();

  constructor(
    private router: Router,
    private breadcrumbService: BreadCrumbService
  ) {
    this.subscriptions.add(this.breadcrumbService.getMenuItems().subscribe(data => {
      this.items = data;
    }));
  }

  items: MenuItem[];

  public redirect(item: MenuItem){
    this.router.navigate(item.routerLink, {queryParams: item.queryParams});
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }


}
